<template>
  <div class="footer">
    <div class="container" style="flex-direction: unset;">
      <div class="copyright">© 2025 Copyright scoretv.cc</div>
      <div class="footer-lang">
        <div 
          class="lang" 
          :class="{ 'unset': applicationLocale !== item.code }" 
          v-for="(item, index) in locales"
          :key="index" 
          @click="onLocaleChange(item)"
        >
          <img src="/static/images/lang_cn.png" class="image" v-if="item.code === 'zh-Hans'" />
          <img src="/static/images/lang_en.png" class="image" v-else />
          {{ item.text }}
        </div>
      </div>
    </div>
    <div class="chat" @click="chat()">
      <img src="/static/images/chat.png"/>
    </div>
    <div class="chat-info" v-if="chat_open">
      <div class="title">
        <span>{{ $t('chat.title') }}</span>
        <i class="el-icon-more" style="font-size: 30px; cursor: pointer;" @click="chat()"></i>
      </div>
      <div class="chat-content">
        <div><img src="/static/images/chat-customer.png" class="chat-customer" /></div>
        <div class="chat-bubble">{{ $t('chat.bubble') }}</div>
      </div>
      <button class="button" @click="go()">{{ $t('chat.button') }}</button>
    </div>
  </div>
</template>

<script>
import i18nUtil from '@/utils/i18n'

export default {
  name: 'Footer',
  props: {
    applicationLocale: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      lang: 'cn',
      systemLocale: '',
      chat_open: false
    }
  },
  computed: {
    locales() {
      return [
        {
          text: this.$t('locale.zh-hans'),
          code: 'zh-Hans'
        },
        {
          text: this.$t('locale.en'),
          code: 'en'
        }
      ]
    }
  },
  mounted() {
  },
  methods: {
    handleImageError(item) {
      // 处理图片显示错误
    },
    onLocaleChange(e) {
      i18nUtil.setLocale(e.code)
      this.$i18n.locale = e.code
      this.$emit('changeLang', e.code)
    },
    chat() {
      this.chat_open = this.chat_open ? false : true
    },
    go() {
      window.location.href = 'https://t.me/letoultaff'
    }
  }
}
</script>

<style>
@import '../../public/static/css/index.css';
</style>
